<template>
  <div class="container fluid">
    <v-card>
      <DigitalDepotAccountsTable />
    </v-card>
  </div>
</template>

<script>
import DigitalDepotAccountsTable from '@/components/digitalDepots/DigitalDepotAccountsTable';

export default {
  name: 'DigitalDepotAccountsView',
  components: {
    DigitalDepotAccountsTable,
  },
  data() {
    return {

    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/digitalDepots/DigitalDepotAccountsView.vue